import { GzGeneralAdvancedWebComponent } from './component/GzGeneralAdvancedWebComponent';

export { GzGeneralAdvancedWebComponent };
